import { computed } from 'vue'
import { useStore } from 'vuex'
import { PERMISSION_KEYS } from '@/store/modules/auth/permissionKeys'

export function usePermissions() {
  const store = useStore()

  const isPermissionEnabled = (keys: string[]) =>
    store.getters['authModule/isPermissionEnabled'](keys)

  return {
    canExportData: computed(() => isPermissionEnabled([PERMISSION_KEYS.EXPORT_ALL])),
    canViewSalesData: computed(() => isPermissionEnabled([PERMISSION_KEYS.VIEW_SALES])),
  }
}
